<template>
  <div :class="$vuetify.breakpoint.xs ? '' : 'pt-3'">
    <v-container fluid
                 v-style:paddingLeft="$valueByBreakpoint($finPadding.left)"
                 v-style:paddingRight="$valueByBreakpoint($finPadding.right)">
      <v-row>
        <v-col cols="12" order="2" order-sm="1" sm="7">
          <fin-lexicon-text :class="$vuetify.breakpoint.xs ? 'strat-desc' : 'strat-desc pr-8'"
                            :text="strategy.description"
                            auto-solve/>
        </v-col>

        <v-col :class="$vuetify.breakpoint.xs ? 'pt-0' : ''" cols="12" order="1" order-sm="2" sm="5">
          <v-row v-if="containedArchetype && profileArchetype" no-gutters>
            <v-col cols="3" sm="5">
              <fin-archetype-illustration :archetype="profileArchetype"
                                          :height="$vuetify.breakpoint.xs ? '100%' : 180"
                                          :width="$vuetify.breakpoint.xs ? 40 : 285"
                                          disable-centered-display
                                          hide-animation
                                          hide-scene
              />
            </v-col>
            <v-col align-self="center" cols="9" sm="7">
              <fin-lexicon-text :text="`Dieses Strategiemodell ist interessant für dich als ${profileArchetype.title}`"
                                auto-solve
                                class="bold"/>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12">
              <fin-lexicon-text v-if="profileArchetype && containedArchetype"
                                class="bold"
                                auto-solve
                                text="Weitere passende Archetypen"/>
              <fin-lexicon-text v-else
                                class="bold"
                                auto-solve
                                text="Passende Archetypen"/>
              <br/>
              <fin-archetype-avatar v-for="(avatar, index) in archetypesWithoutSelected"
                                    :key="index"
                                    :archetype-id="avatar.archetype.id"
                                    :tooltip="avatar.archetype.title"
                                    class="mr-3 mb-1 mt-1"
                                    style="display: inline-block;"
              />
            </v-col>
            <v-col cols="12">
              <fin-lexicon-text class="bold"
                                auto-solve
                                text="Wie hoch ist das Risiko"/>
              <v-icon :size="16" class="mr-2 risk-icon">icon-risk</v-icon>
              <span class="risk-desc">{{ riskDescriptionByEnumVal }}</span>
            </v-col>
          </v-row>

        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import FinArchetypeIllustration from "@/components/pages/onboarding/ArchetypeIllustration"
import {mapGetters} from 'vuex'
import FinLexiconText from "@/components/common/lexicon/LexiconText"
import FinArchetypeAvatar from "@/components/common/ArchetypeAvatar"

const riskMapping = {
  LOW: 'geringe',
  MEDIUM: 'mittlere',
  HIGH: 'hohe'
}

export default {
  name: "finStrategyDetailsOverviewTab",
  components: {FinArchetypeAvatar, FinLexiconText, FinArchetypeIllustration},
  props: {
    strategy: null,
  },
  computed: {
    ...mapGetters('auth', ['profileArchetype']),
    containedArchetype() {
      return !!this.strategy.archetypes.items.find(a => a.archetype.id === this.profileArchetype?.id)
    },
    archetypesWithoutSelected() {
      return this.strategy.archetypes.items.filter(a => a.archetype.id !== this.profileArchetype?.id)
    },
    riskDescriptionByEnumVal() {
      const risk = this.strategy.riskCategories
      let riskDesc = '-'

      // TODO replace fixed values by db calls (i18n)
      if (risk.length === 1) {
        riskDesc = riskMapping[risk[0]] + ' Risikoneigung'
      } else if (risk.length >= 1) {
        riskDesc = riskMapping[risk[0]] + ' bis ' + riskMapping[risk[risk.length - 1]] + ' Risikoneigung'
      }

      return riskDesc
    }
  },
}
</script>

<style lang="scss" scoped>
.bold {
  font-family: $body-font-family;
  font-size: 14px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.39;
  letter-spacing: normal;
  color: $fin-color-primary-dark;
}

.strat-desc {
  font-family: $body-font-family;
  font-size: 16px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.5;
  letter-spacing: normal;
  color: $fin-color-primary-dark;
  /* additional */
  white-space: pre-line;
}

.risk-icon {
  float: left;
  display: block;
}

.risk-desc {
  font-family: $body-font-family;
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  letter-spacing: normal;
  color: $fin-color-primary-dark;
  /* additional */
  line-height: 16px;
  display: block;
}
</style>
